import Swiper from "swiper";
import {
	EffectFade,
	Pagination,
	Navigation,
	Scrollbar,
	Thumbs,
	FreeMode,
	Grid,
	Mousewheel,
	Autoplay,
} from "swiper/modules";
/**
 * @param swiperInit
 */
export function swiperInit () {
	swipePartnerMarquee();
	swiperBanner();
	swiperService();
	swiperProduct();
	swiperPartnerThumb();
	swiperHome8Thumb();
	swiperHistory();
	swiperDirector();
	swiperAchievement();
	swiperProductDetail2();
	swiperDetail6();
	swiperDetail7();
	// swiperDetail8();
	swiperOperatopm();
	swiperDeman();
	swiperOperationCustomers();
	window.Swiper = Swiper;
	window.Autoplay = Autoplay;
	window.Pagination = Pagination;
	window.swiperBanner = swiperBanner;

	window.swiperProduct = swiperProduct;

	window.swiperHome8Thumb = swiperHome8Thumb;
	window.swiperHistory = swiperHistory;
	window.swiperDirector = swiperDirector;
	window.swiperAchievement = swiperAchievement;
	window.swiperProductDetail2 = swiperProductDetail2;
	window.swiperDetail6 = swiperDetail6;
	window.swiperDetail7 = swiperDetail7;
	window.swiperDetail8 = swiperDetail8;
	window.swiperOperatopm = swiperOperatopm;
	window.swiperDeman = swiperDeman;
	window.swiperOperationCustomers = swiperOperationCustomers;
	window.swiperAuto = swiperAuto;
	swiperAuto();
}

function swiperAuto () {
	$(".swiper-column-auto").each(function (index) {
		const $this = $(this);
		// Configuration flagsvideoSetting
		const config = {
			loop: $this.hasClass("swiper-loop"),
			touchMove: $this.hasClass("allow-touchMove") || true,
			mouseWheel: $this.hasClass("allow-mouseWheel") ? { forceToAxis: true } : false,
			autoHeight: $this.hasClass("auto-height"),
			hasVideo: $this.hasClass("auto-detect-video"),
			progressbar: $this.hasClass("progressbar"),
			time: $this.attr("data-time") || 3500,
			autoplay: $this.hasClass("autoplay"),
			nested: $this.hasClass("nested") || false,
		};

		// Add unique identifier class
		$this.addClass(`swiper-column-auto-id-${index}`);

		// Create swiper with optimized options
		new Swiper(`.swiper-column-auto-id-${index} .swiper`, {
			modules: [Navigation, Pagination, Mousewheel, Autoplay],
			speed: 500,
			observer: true,
			nested: config.nested,
			observeParents: true,
			spaceBetween: 0,
			loop: config.loop,
			...(config.autoplay && {
				autoplay: {
					delay: config.time,
				},
			}),
			slidesPerView: "auto",
			pagination: {
				el: `.swiper-column-auto-id-${index} .swiper-pagination`,
				clickable: true,
				...(config.progressbar && {
					type: 'progressbar',
				}),
			},
			mousewheel: config.mouseWheel,
			allowTouchMove: config.touchMove,
			navigation: {
				prevEl: `.swiper-column-auto-id-${index} .btn-prev`,
				nextEl: `.swiper-column-auto-id-${index} .btn-next`,
			},
			watchSlidesProgress: true,
			on: {
				init: function () {
				},
				slideChange: function () {
				},
			},
		});
	});
}

function swiperBanner () {
	const swiper = new Swiper(".home-1 .swiper", {
		slidesPerView: 1,
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".home-1 .btn-next",
			prevEl: ".home-1 .btn-prev",
		},
	});
	window.swiperBanner = {
		swiper,
	};
}

function swiperHomeBannerMobile () {
	const swiperHomeBannerMobile = new Swiper(".home-1-mobile .swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		speed: 1000,
		autoplay: {
			delay: 3500,
		},
		navigation: {
			nextEl: ".home-1-mobile .btn-next",
			prevEl: ".home-1-mobile .btn-prev",
		},
	});
}

function swiperService () {
	const swiper = new Swiper(".home-3 .swiper", {
		slidesPerView: 1.2,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		modules: [Autoplay, Navigation],
		rewind: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".home-3 .btn-next",
			prevEl: ".home-3 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 15,
			},
		},
	});

	// Lưu trực tiếp instance ra global
	window.swiperService = swiper;
}

function swiperProduct () {
	const productSwipers = [];

	// 1. Khởi tạo Swiper cho từng tab-panel trong home-4
	$(".home-4 .tabslet-content").each(function () {
		const $panel = $(this);
		const swiperEl = $panel.find(".swiper")[0];
		if (!swiperEl) return;

		// Chỉ init nếu chưa có swiper instance
		if (!swiperEl.swiper) {
			const sw = new Swiper(swiperEl, {
				modules: [Autoplay, Navigation],
				loop: true,
				speed: 1000,
				autoplay: {
					delay: 3500,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				navigation: {
					nextEl: $panel.find(".btn-next")[0],
					prevEl: $panel.find(".btn-prev")[0],
				}, 
				slidesPerView: 2,
				observer: true,
				observeParents: true,
				watchSlidesProgress: true,
				spaceBetween: 15,
				breakpoints: {
					768: {
						slidesPerView: 3,
						spaceBetween: 15,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 40,
					},
				},
			});

			$panel.data("swiperProduct", sw);
			productSwipers.push(sw);
		}
	});

	// 2. Stop autoplay trước khi chuyển tab
	// $(document).on("tabslet:before", function () {
	// 	productSwipers.forEach((sw) => {
	// 		if (sw.autoplay && sw.autoplay.running) {
	// 			sw.autoplay.stop();
	// 		}
	// 	});
	// }); 

	// 3. Start lại autoplay khi tab hiển thị
	// $(document).on("tabslet:after", function (e, tab) {
	// 	const $panel = $(tab);
	// 	setTimeout(() => {
	// 		$panel.find(".swiper").each(function () {
	// 			const sw = this.swiper;
	// 			if (!sw) return;
	// 			sw.update();
	// 			if (sw.autoplay && !sw.autoplay.running) {
	// 				sw.autoplay.start();
	// 			}
	// 		});
	// 	}, 50);
	// });
	window.swiperProduct = {
		swiperProduct,
	};
}

function swiperPartnerThumb () {
	const thumbSelector = `.business .thumb .swiper`;
	const mainSelector = `.business .main .main-swiper`; // Đã tách riêng
	const nextBtn = `.business .btn-next`;
	const prevBtn = `.business .btn-prev`;

	// Swiper thumbnail
	const thumbSwiper = new Swiper(thumbSelector, {
		modules: [Navigation, Autoplay],
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},

		slidesPerView: 2,
		spaceBetween: 12,
		watchSlidesProgress: true,
		allowTouchMove: true,
		watchOverflow: true,
		slideToClickedSlide: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 2,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 12,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
		rewind: true,
	});

	// Swiper chính (main)
	const mainSwiper = new Swiper(mainSelector, {
		modules: [Navigation, Thumbs, Autoplay],
		slidesPerView: 1,
		speed: 500, 
		nested: true,
		autoHeight: true,
		allowTouchMove: false,
		rewind: true,
		navigation: {
			nextEl: nextBtn,
			prevEl: prevBtn,
		},
		thumbs: {
			swiper: thumbSwiper,
		},
	});

	// Init các Swiper con bên trong mỗi .img
	document.querySelectorAll(".business .inner-swiper").forEach((el) => {
		new Swiper(el, {
			modules: [Pagination],
			slidesPerView: 1,
			nested: true, // Bắt buộc khi lồng
			// allowTouchMove: false,
			loop: true,
			pagination: {
				el: el.querySelector(".swiper-pagination"),
				clickable: true,
			},
		});
	});
	window.swiperPartnerThumb = {
		thumbSwiper,
		mainSwiper,
		update () {
			this.thumbSwiper.update();
			this.mainSwiper.update();
		},
	};
}

function swiperHistory () {
	const swiper = new Swiper(".about-4 .swiper", {
		slidesPerView: 1.5,
		spaceBetween: 15,
		modules: [Navigation],
		loop: false,
		speed: 1000,
		navigation: {
			nextEl: ".about-4 .btn-next",
			prevEl: ".about-4 .btn-prev",
		},
		breakpoints: {
			768: { slidesPerView: 1.5, spaceBetween: 15 },
			1024: { slidesPerView: 4, spaceBetween: 16 },
			1200: { slidesPerView: 3.8, spaceBetween: 40 },
		},
	});

	const yearItems = document.querySelectorAll(".wrap-year-item");

	yearItems.forEach((item) => {
		item.addEventListener("click", function () {
			const id = this.dataset.id;
			const targetSlide = Array.from(swiper.slides).find((slide) => slide.dataset.id === id);

			if (targetSlide) {
				const targetIndex = Array.from(swiper.slides).indexOf(targetSlide);
				swiper.slideTo(targetIndex, 1000);

				// Active year item
				yearItems.forEach((el) => el.classList.remove("active"));
				this.classList.add("active");

				// Active slide tương ứng
				swiper.slides.forEach((slide) => slide.classList.remove("swiper-slide-active"));
				targetSlide.classList.add("swiper-slide-active");
			}
		});
	});

	// Khi swiper thay đổi → sync active year
	swiper.on("slideChange", function () {
		const currentId = swiper.slides[swiper.activeIndex].dataset.id;
		yearItems.forEach((el) => {
			el.classList.toggle("active", el.dataset.id === currentId);
		});
	});

	// 🚀 Active mặc định year đầu + slide đầu
	if (yearItems.length > 0) {
		yearItems.forEach((el) => el.classList.remove("active"));
		yearItems[0].classList.add("active");
	}
	if (swiper.slides.length > 0) {
		swiper.slideTo(0, 0);
		swiper.slides[0].classList.add("swiper-slide-active");
	}
}

function swiperDirector () {
	const swiper = new Swiper(".about-5 .swiper", {
		slidesPerView: 2,
		spaceBetween: 12,

		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".about-5 .btn-next",
			prevEl: ".about-5 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 50,
			},
		},
	});
	window.swiperDirector = {
		swiper,
	};
}

function swiperAchievement () {
	const swiper = new Swiper(".about-6 .swiper", {
		slidesPerView: 2,
		spaceBetween: 15,
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".about-6 .btn-next",
			prevEl: ".about-6 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 15,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 72,
			},
		},
	});
	window.swiperAchievement = {
		swiper,
	};
}

function swiperProductDetail2 () {
	const swiper = new Swiper(".product-detail-2 .swiper", {
		slidesPerView: 1,
		spaceBetween: 12,
		grabCursor: true,
		modules: [Autoplay, Navigation, Scrollbar],
		speed: 1000,
		navigation: {
			nextEl: ".product-detail-2 .btn-next",
			prevEl: ".product-detail-2 .btn-prev",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
			hide: false,
			draggable: true, 
		},
		on: {
			init: function (swiper) {
				const length = swiper.slides.length;
				const currentSlidePerView = swiper.params.slidesPerView;
				console.log(length, currentSlidePerView);
				if (length <= currentSlidePerView) { 
					$(swiper.el).closest(".product-detail-2").find(".indicator-swipe").hide();
				} else {
				}
			},
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
		},
	});
	window.swiperProductDetail2 = {
		swiper,
	};
}

function swiperDetail6 () {
	const container = $(".product-detail-6-slide");

	const defaultBg = container.attr("setBackground") || "";

	const swiper = new Swiper(".product-detail-6 .swiper", {
		slidesPerView: 1.2,
		modules: [Autoplay, Navigation],
		loop: false,
		autoplay: {
			delay: 4500,
			disableOnInteraction: false,
		},
		speed: 1500,
		navigation: {
			nextEl: ".product-detail-6 .btn-next",
			prevEl: ".product-detail-6 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		on: {
			init: function () {
				updateBackground(this.slides[this.activeIndex]);
				initHoverBackground(); // Gọi hover sau khi khởi tạo
			},
			slideChange: function () {
				console.log(this.slides[this.activeIndex]);
				updateBackground(this.slides[this.activeIndex]);
			},
		},
	});

	function updateBackground (activeSlide) {
		const bg = $(activeSlide).attr("data-background") || defaultBg;
		container.css({
			"background-image": `url(${bg})`,
			"background-size": "cover",
			"background-position": "center",
			transition: "background-image 0.5s ease-in-out",
		});
	}

	function initHoverBackground () {
		$(".product-detail-6 .swiper-slide").hover(
			function () {
				const bg = $(this).attr("data-background");
				if (bg) {
					container.css("background-image", `url(${bg})`);
				}
			},
			function () {
				// Trở lại ảnh của slide đang active
				const activeSlide = swiper.slides[swiper.activeIndex];
				updateBackground(activeSlide);
			}
		);
	}

	window.swiperDetail6 = {
		swiper,
	};
}

function swipePartnerMarquee () {
	const swiperPartner = new Swiper(".about-1 .swiper-partner", {
		modules: [Autoplay],
		slidesPerView: "auto",
		spaceBetween: 8,
		loop: true,
		autoplay: {
			delay: 0,
			pauseOnMouseEnter: false, 
			disableOnInteraction: false,
		},
		freeMode: true,
		speed: 7000, // bỏ transition để dịch chuyển tức thời
	});

	// let speed = 0.5; // px/frame
	// let rafId;

	// function animate () {
	// 	swiperPartner.setTranslate(swiperPartner.getTranslate() - speed);
	// 	rafId = requestAnimationFrame(animate);
	// }

	// // Bắt đầu auto scroll
	// animate();

	// // --- Dùng sự kiện Swiper để tránh lỗi el ---
	// swiperPartner.on("touchStart", () => cancelAnimationFrame(rafId));
	// swiperPartner.on("touchEnd", animate);
	// swiperPartner.on("sliderFirstMove", () => cancelAnimationFrame(rafId)); // PC kéo bằng chuột
	// swiperPartner.on("transitionEnd", animate);

	// // Nếu vẫn muốn check thủ công (trường hợp đặc biệt)
	// if (swiperPartner.el && swiperPartner.el instanceof HTMLElement) {
	// 	swiperPartner.el.addEventListener("mousedown", () => cancelAnimationFrame(rafId));
	// 	swiperPartner.el.addEventListener("mouseup", animate);
	// 	swiperPartner.el.addEventListener("touchstart", () => cancelAnimationFrame(rafId));
	// 	swiperPartner.el.addEventListener("touchend", animate);
	// }
}

function swiperDetail7 () {
	const swiper = new Swiper(".product-detail-7 .swiper", {
		modules: [Autoplay, Navigation],
		loop: true,
		slidesPerView: "auto",
		centeredSlides: true,
		spaceBetween: 80,
		speed: 1000,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".product-detail-7 .btn-next",
			prevEl: ".product-detail-7 .btn-prev",
		},
		on: {
			slideChangeTransitionEnd: function () {
				// Kích hoạt reflow để CSS áp dụng lại hiệu ứng
				const activeSlide = document.querySelector(".swiper-slide-active");
				if (activeSlide) {
					activeSlide.style.animation = "none";
					void activeSlide.offsetWidth; // Trigger reflow
					activeSlide.style.animation = null;
				}
			},
		},
	});

	window.swiperDetail7 = {
		swiper,
	};
}

function swiperDetail8 () {
	const swiper = new Swiper(".product-detail-8 .swiper", {
		slidesPerView: 1,
		spaceBetween: 12,

		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".product-detail-8 .btn-next",
			prevEl: ".product-detail-8 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});
	window.swiperDetail8 = {
		swiper,
	};
}

function swiperHome8Thumb () {
	const root = document.querySelector(".home-8"); // Hoặc bất kỳ ID nào đúng với Pug bạn đặt
	if (!root) return;

	const thumbSelector = root.querySelector(".thumb .swiper");
	const mainSelector = root.querySelector(".main .swiper");
	const nextBtn = root.querySelector(".btn-next");
	const prevBtn = root.querySelector(".btn-prev");

	const thumbSwiper = new Swiper(thumbSelector, {
		modules: [Navigation, Autoplay],
		slidesPerView: 2,
		spaceBetween: 12,
		watchSlidesProgress: true,
		allowTouchMove: true,
		watchOverflow: true,
		slideToClickedSlide: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 2,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 12,
			},
			1200: {
				slidesPerView: 6,
				spaceBetween: 24,
			},
		},
		rewind: true,
	});

	const mainSwiper = new Swiper(mainSelector, {
		modules: [Navigation, Thumbs, Autoplay, EffectFade],
		slidesPerView: 1,
		watchOverflow: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 500,
		autoHeight: true,
		rewind: true,
		navigation: {
			nextEl: nextBtn,
			prevEl: prevBtn,
		},
		thumbs: {
			swiper: thumbSwiper,
		},
	});

	thumbSwiper.on("click", (swiper) => {
		const index = swiper.clickedIndex;
		if (index === undefined) return;

		let visibleCount = swiper.slidesPerViewDynamic?.() ?? parseInt(swiper.params.slidesPerView);
		if (isNaN(visibleCount)) visibleCount = 1;

		const totalSlides = swiper.slides.length;
		let centerIndex = Math.max(index - Math.floor(visibleCount / 2), 0);
		centerIndex = Math.min(centerIndex, totalSlides - visibleCount);

		swiper.slideTo(centerIndex);
		mainSwiper.slideTo(index);
	});
}

function swiperOperationCustomers () {
	const swiper = new Swiper(".operation-6 .swiper", {
		slidesPerView: 2,
		spaceBetween: 15,
		modules: [Grid, Pagination, Navigation],
		grid: {
			rows: 2,
			fill: "row",
		},
		navigation: {
			nextEl: ".operation-6 .btn-next",
			prevEl: ".operation-6 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 15,
				grid: {
					rows: 3,
					fill: "row",
				},
			},
			1200: {
				grid: {
					rows: 3,
					fill: "row",
				},
				slidesPerView: 5,
				spaceBetween: 40,
			},
		},
	});
}

function swiperOperatopm () {
	const swiper = new Swiper(".operation-2 .swiper", {
		slidesPerView: 2,
		spaceBetween: 12,

		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".operation-2 .btn-next",
			prevEl: ".operation-2 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 40,
			},
		},
	});
	window.swiperOperatopm = {
		swiper,
	};
}

function swiperDeman () {
	const swiper = new Swiper(".operation-5 .swiper", {
		slidesPerView: 1,
		spaceBetween: 12,
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},
		speed: 1000,
		navigation: {
			nextEl: ".operation-5 .btn-next",
			prevEl: ".operation-5 .btn-prev",
		},
	});
	window.swiperDeman = {
		swiper,
	};
}

